// The default matches Shopify's GraphQL page size, while the maximum bounds total results.
export const DEFAULT_LIST_LIMIT = 250;
export const MAX_LIST_LIMIT = 1_000;
